// extracted by mini-css-extract-plugin
export default {"row":"bpPm1g","title":"TesvWq","price":"GaZZ35","feeName":"rIKDEG","taxesPopoverWrapper":"mzwz2A"};